import axios from '@/axios'
import Vue from 'vue'

const state = {
  quizzes: [],
};

const actions = {
  fetchQuizzes({ commit }, config) {
    return axios.get('quizzes', config)
      .then((r) => {
        if (r.data.success) {
          commit('SAVE_QUIZZES', r.data.quizzes)
        } else {
          throw new Error("Quizzes forbidden");
        }
      })
  }
};

const mutations = {
  SAVE_QUIZZES(state, messages) {
    Vue.set(state, 'quizzes', messages);
  },
};

export default {
  state,
  actions,
  mutations
}
